import { render } from "./CargoGroup.vue?vue&type=template&id=62171556&ts=true"
import script from "./CargoGroup.vue?vue&type=script&lang=ts"
export * from "./CargoGroup.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Work\\АСУП\\OptiLoadingPaper\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__